import React from "react";

import * as S from "./styles";

const Ideas: React.FC = () => {
  return (
    <S.Container>
      <S.Wrapper
        className="wow animate__animated animate__fadeIn"
        data-wow-duration="1s"
      >
        <S.Text>
          “Quando eu trabalhava na loja da Cris Barros, a gente tinha meta de
          vendas para bater. Foi assim que eu comecei a fazer ‘o provador da
          Thai’ nos meus Stories”, relembra, sobre a série de vídeos engraçados
          que gravava em frente ao espelho com os looks da marca. “Menina,
          coloca uma meta de vendas na sua vida para ver se a coisa não anda.
          Era o puro desespero!”, fala, entre uma e outra gargalhada. “Eu sou
          insuportavelmente feliz. Já pensei muito sobre a morte e, quando eu
          aceitei a finitude das coisas como uma parte inerente da vida, decidi
          viver o presente com o máximo de felicidade possível. A vida é agora!”
        </S.Text>
      </S.Wrapper>
      <S.Girl
        className="wow animate__animated animate__zoomIn"
        data-wow-duration="1s"
      />
      <S.PhotosWrapper>
        <S.PhotoContent>
          <S.GirlBw
            className="wow animate__animated animate__zoomIn"
            data-wow-duration="1s"
          />
        </S.PhotoContent>
        <S.PhotoContent className="right">
          <S.GirlMini
            className="wow animate__animated animate__zoomIn"
            data-wow-duration="1s"
          />
        </S.PhotoContent>
      </S.PhotosWrapper>
      <S.Wrapper>
        <S.Text
          className="wow animate__animated animate__fadeIn"
          data-wow-duration="1s"
        >
          O caminho para encontrar essa luz interior, no entanto, foi longo. Aos
          23 anos, Thai engravidou do seu atual marido. Depois da gravidez, deu
          de cara com a anorexia e, com os sentimentos embaralhados, não
          conseguiu amar a maternidade no seu início. “Gosto de dizer que o
          universo brinca comigo. Quando estava sem noção do meu corpo, fui
          fazer yoga para emagrecer. De repente, a yoga e a meditação me tiraram
          do buraco. Pratico há dez anos e indico fortemente. Se você diz que
          não tem paciência para yoga, é exatamente por isso que você deve
          começar logo.” A construção e o reconhecimento da sua própria força
          vieram com o tempo: “Você tem que pensar que todo passinho rumo à
          autoconfiança e à coragem é válido. Não adianta querer correr uma
          maratona se você nem sabe engatinhar. Pense no hoje, foque no que dá
          para fazer. Quando você vê, já é uma nova pessoa.”
        </S.Text>
      </S.Wrapper>
    </S.Container>
  );
};

export default Ideas;
